import { Components } from '../../common/interfaces';
export var Strings = {
  ADD_COUPON_SUCCESS: 'Coupon added successfully. You will be charged ${price} today.',
  AUTOFILL_ADD_SUCCESS: 'Autofilled coupon added successfully',
  COUPON_REQUIRED: 'No code provided.',
  COUPON_REMOVED: 'Coupon removed. You will be charged ${price} today.',
  COUPON_REMOVE_ERROR: 'Unable to remove coupon.',
  INVALID_CODE: 'The coupon code wasn’t captured or is invalid. Please try again.',
  UNKNOWN_ERROR: 'Unknown error.',
  MISSING_CONTENT_ERROR: "".concat(Components.COUPON, " component requires buttonText, placeholderText, labelText, addCouponText  to be passed in.")
};
export var ErrorTypes = /*#__PURE__*/function (ErrorTypes) {
  ErrorTypes["REQUIRED"] = "required";
  return ErrorTypes;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/Coupon/strings.js
// module id = 1385
// module chunks = 11